export default "__VITE_ASSET__CJwhffZI__"